// extracted by mini-css-extract-plugin
module.exports = {"btn":"payment_btn__bXyYX","btnHide":"payment_btnHide__H6Yzi"};